import React from 'react'

const usePrevious = (val: unknown) => {
  const ref = React.useRef(val)

  React.useEffect(() => {
    ref.current = val
  }, [val])

  return ref.current
}

export default usePrevious
